export interface IMCell {
  height: number;
  offset: number;
  page_number: number;
  text: string;
  width: number;
  x: number;
  y: number;
  readonly?: boolean; // 只读
  classnames?: string;
  error?: boolean;
  highlight?: boolean;
}

export type IMCells = IMCell[][];
export type IMMask = number[][];
export type IMTextMatrix = string[][];

export interface IMTable {
  cells: IMCells;
  table_id: string;
  mask: IMMask;
  text_matrix: IMTextMatrix;
}

export interface IMCellIndex {
  rowIndex: number;
  colIndex: number;
}

export interface IMCellTextChange {
  cell: IMCell;
  cellIndex: IMCellIndex;
  text: string;
}

export interface IMCellClickEvent {
  cell: IMCell;
  cellIndex: IMCellIndex;
}

export interface IMCellOperationVisible {
  cell: IMCell;
  cellIndex: IMCellIndex;
}

export interface IMCellOperationClickEvent {
  cell: IMCell;
  cellIndex: IMCellIndex;
  label?: string;
}

export interface IMTableScrollToCell {
  tableId: string;
  rowIndex: number;
  colIndex: number;
}

export interface IMTableHighlightCell {
  tableId: string;
  rowIndex: number;
  colIndex: number;
}

export enum EMTableOperationDirection {
  before = 'before',
  after = 'after'
}

export interface IMTableOperation {
  icon?: string | (() => string);
  label?: string | (() => string);
  visible?(data: IMCellOperationVisible): boolean;
  onClick?(event: IMCellOperationClickEvent): void;
}

export interface IMTableHeadOperation {
  label?: string | (() => string);
  visible?(data: IMCellOperationVisible): boolean;
}
